export enum FieldMenuActionType {
  Settings = 1,
  Recipients = 2,
  TextSize = 3,
  Move = 4,
  Duplicate = 5,
  Align = 6,
  Delete = 7,
}
